import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import ArrowIcon from "@iconify/icons-mdi/arrow-right-bold";
import { InlineIcon } from "@iconify/react";
import { useMyHrEmployee } from "my-hr/hooks";
import { OcAvatar, OcCalendarDay, OcStateChip } from "oc/components";
import { getFullname } from "oc/utils";

interface MyLeaveCardHeaderProps {
  employee: any; // Replace 'any' with the actual employee type if available
  leaveRequest: any; // Replace 'any' with the actual leaveRequest type if available
  loading: boolean;
  isMobile: boolean;
}

export const MyLeaveCardHeader: React.FC<MyLeaveCardHeaderProps> = ({
  employee,
  leaveRequest,
  loading,
  isMobile,
}) => {
  const { t } = useTranslation();

  const { data: approvedCode } = useMyHrEmployee({
    employeeId: leaveRequest?.approvedBy,
  });
  const { data: rejectedCode } = useMyHrEmployee({
    employeeId: leaveRequest?.rejectedBy,
  });

  return (
    <Box display="flex" flexDirection={isMobile ? "column-reverse" : "unset"}>
      <Box>
        {!isMobile && (
          <OcAvatar
            employee={employee?.code}
            style={{
              width: "100px",
              height: "100px",
            }}
          />
        )}{" "}
      </Box>
      <Box flexGrow={1} padding="0px 0px 0px 16px">
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Box fontSize="20px" letterSpacing="0.15px" paddingBottom="22px">
            {getFullname(employee)}
          </Box>
          <Box display="flex" flexDirection="column" alignItems="center">
            <Box height="1px" />
            {!loading && <Box fontSize="9px" style={{ color: "#919699" }}>
              {new Date(leaveRequest?.createdAt).toLocaleDateString()}
            </Box>}
            <Box height="2px" />
            {(leaveRequest?.state === "approved" ||
              leaveRequest?.state === "assigned") && (
                <Box fontSize="9px" paddingTop="1px" style={{ color: "#919699" }}>
                  {getFullname(approvedCode)}
                </Box>
              )}
            {leaveRequest?.state === "rejected" && (
              <Box fontSize="9px" style={{ color: "#919699" }}>
                {getFullname(rejectedCode)}
              </Box>
            )}
            <Box height="2px" />
            <OcStateChip
              label={!loading && t(`MY_LEAVE_${leaveRequest?.state.toUpperCase()}`)}
              state={leaveRequest?.state}
              loading={loading}
              variant="body2"
            />
          </Box>
        </Box>
        {isMobile && <Box height="20px" />}
        <Box display="flex" flexDirection="row" alignItems="center">
          <OcCalendarDay date={leaveRequest?.startDate} loading={loading} unPaidDate={false} />
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            padding="4px"
          >
            <InlineIcon icon={ArrowIcon} />
          </Box>
          <OcCalendarDay date={leaveRequest?.endDate} loading={loading} unPaidDate={false} />
          <Box padding="0px 20px" marginTop="-4px">
            <Box fontSize="16px" letterSpacing="0.44px">
              {!loading && t(`MY_LEAVE_${leaveRequest?.leaveType}`)}
            </Box>
            <Box fontSize="14px" letterSpacing="0.25px" paddingTop="3px">
              {leaveRequest?.effectiveWorkDays?.toLocaleString()}{" "}
              {!loading && t("OC_WORKDAYS")}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default MyLeaveCardHeader;
